import type { IFieldOptions } from '@axo/form/feature/form-input/types';

export const ownerAssociationCostMonthlyFieldOptions = {
  registerOptions: {
    shouldUnregister: true,
    required: 'OwnerAssociationCostMonthly.error.required',
    max: {
      value: 5_000,
      message: 'OwnerAssociationCostMonthly.error.amount',
    },
  },
  warningValidation: {
    message: (value) => {
      const amount = Number(value);
      if (!amount) return;

      if (amount > 1_200) {
        return 'OwnerAssociationCostMonthly.error.soft.high';
      }

      if (amount < 100) {
        return 'OwnerAssociationCostMonthly.error.soft.low';
      }
    },
  },
  tooltipValidation: {
    message: 'OwnerAssociationCostMonthly.tooltip',
  },
} satisfies IFieldOptions;
